import {
  aDeleteMatchList,
  mockDeleteMatchListOperationMutation,
} from '__generated__';
import { delay, HttpResponse } from 'msw';

export const deleteMatchListOperationResponse = {
  __typename: 'Mutation' as const,
  deleteMatchList: aDeleteMatchList(),
};

export const handlers = [
  mockDeleteMatchListOperationMutation(
    async ({ query: _query, variables: _variables }) => {
      await delay(1500);
      return HttpResponse.json({
        data: {
          ...deleteMatchListOperationResponse,
        },
      });
    }
  ),
];
